// extracted by mini-css-extract-plugin
export var link = "_tt-0";